import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '../public';
import Swal from 'sweetalert2';

export const useDashboardStore = defineStore('dashboard', {
  state: () => ({
    key_metrics: [],
    active_drivers_by_payment_method: [],
    terminals: [],
    cards: [],
    management_dashboard: [],
    filter: 'General',
  }),
  actions: {
    async fetchDashboard() {
      const url = `/api/admin/dashboard/info`;
      
      try {
        const response = await useHttp().get(`${url}`);
        this.key_metrics = response.data.result.key_metrics;
        this.active_drivers_by_payment_method = response.data.result.active_drivers_by_payment_method;
        this.terminals = response.data.result.terminals;       
        this.cards = response.data.result.cards;
      } catch (error) {
        console.error('Error fetching terminal performances:', error);
      }
    },
    async fetchManagementDashboard() {
      const url = `/api/admin/dashboard/management/info`;
      
      try {
        const response = await useHttp().get(`${url}`);
        this.management_dashboard = response.data.result;   
      } catch (error) {
        console.error('Error fetching terminal performances:', error);
      }
    },
    async updateCommission(payload) {
      const url = `/api/admin/dashboard/commission`;
      
      try {
        const response = await useHttp().post(`${url}`, payload);
        if(statusCheck(response)){
          this.fetchManagementDashboard();
          Swal.fire({
            icon: 'success',
            title: 'Commission updated successfully',
          });
        }
      } catch (error) {
        console.error('Error fetching terminal performances:', error);
      }
    },
  },
});
